export default "__VITE_ASSET__fcd967ec__"